import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import CancelIcon from "@mui/icons-material/Cancel";
import { Divider, CircularProgress } from "@mui/material";
import Noticom from "./Noticom";
import { useEffect, useState } from "react";
import getServices from "../../Services/get-service";
import NotificationSkeleton from "../SkeletonComponent/NotificationSkeleton";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "white",
  boxShadow: 24,
  outline: "none",
  border: "none",
};

function Notification({ open, handleClose, refreshCount }) {
  const [noti, setNotification] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchNotifications = async () => {
    setLoading(true);
    try {
      const response = await getServices.getNotifications();
      if (
        response.data &&
        response.data.data &&
        response.data.data.notifications
      ) {
        setNotification(response.data.data.notifications);
      } else {
        setNotification([]);
      }
    } catch (error) {
      // console.error( error);
      setNotification([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      fetchNotifications();
    }
  }, [open]);

  const handleReadAll = async () => {
    // Optimistic update
    const previousNoti = [...noti];
    setNotification(noti.map((item) => ({ ...item, read: true })));
    if (refreshCount) refreshCount();

    try {
      await getServices.readAllNotifications();
      if (refreshCount) refreshCount();
      // fetchNotifications(); // Already optimistically updated
    } catch (error) {
      // Revert on error
      setNotification(previousNoti);
      if (refreshCount) refreshCount();
    }
  };

  const handleReadSingle = async (id) => {
    // Optimistic update
    const previousNoti = [...noti];
    setNotification(
      noti.map((item) => (item.id === id ? { ...item, read: true } : item)),
    );
    if (refreshCount) refreshCount();

    try {
      await getServices.readSingleNotification(id);
      if (refreshCount) refreshCount();
      // fetchNotifications();
    } catch (error) {
      // Revert on error
      setNotification(previousNoti);
      if (refreshCount) refreshCount();
    }
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={style} className="h-[80%]  p-4 pt-5 rounded-md">
            <div className=" md:mt-5">
              <div className=" mt-6 flex justify-between mb-3 items-center">
                <div>
                  <h1 className=" font-[500] text-[20px] text-back-color2">
                    Notifications
                  </h1>
                </div>
                <div className="flex items-center gap-4">
                  {noti.length > 0 && (
                    <p
                      onClick={handleReadAll}
                      className="text-primary-color cursor-pointer text-sm font-medium hover:underline"
                    >
                      Mark all as read
                    </p>
                  )}
                  <CancelIcon
                    onClick={handleClose}
                    className=" text-back-color2 cursor-pointer text-[38px]"
                    fontSize="large"
                  />
                </div>
              </div>
              <Divider />
              <div className=" pt-5">
                {loading ? (
                  <NotificationSkeleton />
                ) : (
                  <>
                    {noti.map((item, index) => (
                      <div key={item.id || index}>
                        <Noticom
                          data={item}
                          onRead={() => handleReadSingle(item.id)}
                        />
                      </div>
                    ))}
                    {noti.length === 0 && (
                      <div className="py-10">
                        <p className=" text-center text-gray-500 text-lg">
                          No notification yet
                        </p>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}

export default Notification;
